import Markdown from 'react-markdown';
export interface IFAQItem {
  title: string;
  content: string;
}

export const allowedMarkdownTypes: Markdown.NodeType[] = [
  'text',
  'root',
  'break',
  'paragraph',
  'emphasis',
  'strong',
  'link',
  'list',
  'listItem',
  'heading',
  'thematicBreak',
  'html',
];
